/* Planetee - prechargement au survol/toucher (navigation quasi-instantanee).
   Sur touchstart (mobile) ou mouseover (desktop), precharge la page cible AVANT le clic.
   Se limite aux liens produits/collections de la boutique. Reversible : retirer la ligne du theme. */
(function () {
  "use strict";
  var done = {};
  var supportsPrefetch = (function () {
    try { var l = document.createElement("link"); return !!(l.relList && l.relList.supports && l.relList.supports("prefetch")); }
    catch (e) { return false; }
  })();
  function warm(url) {
    if (done[url]) return; done[url] = 1;
    if (supportsPrefetch) {
      var l = document.createElement("link");
      l.rel = "prefetch"; l.href = url; l.as = "document";
      document.head.appendChild(l);
    } else {
      try { fetch(url, { credentials: "include" }).catch(function () {}); } catch (e) {}
    }
  }
  function eligible(a) {
    return a && a.href && a.hostname === location.hostname &&
      a.href.indexOf("#") === -1 &&
      /\/(products|collections)\//.test(a.pathname) &&
      !a.hasAttribute("download") && a.target !== "_blank";
  }
  function onIntent(e) {
    var a = e.target && e.target.closest ? e.target.closest("a") : null;
    if (eligible(a)) warm(a.href.split("#")[0]);
  }
  document.addEventListener("mouseover", onIntent, { capture: true, passive: true });
  document.addEventListener("touchstart", onIntent, { capture: true, passive: true });
})();
